import React, { useEffect, useState } from "react";
import Pagination from "./Pagination";

const TEMPLATE_COLUMNS = [
  { Header: "Email", accessor: "useremail" },
  { Header: "Product Description", accessor: "productdescription" },
  { Header: "Batch No.", accessor: "batchno" },
  { Header: "Quantity", accessor: "quantity" },
  { Header: "Value", accessor: "value" },
  { Header: "Date Time", accessor: "datetime" },
];

const TemplateTable = ({ data = [], onDownload, pageSize = 10 }) => {
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    setCurrentPage(1);
  }, [data, pageSize]);

  const totalPages = Math.ceil(data.length / pageSize);
  const pageRows = data.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize,
  );

  return (
    <>
      <div className="customTable__body">
        <div className="table-responsive">
          <table className="table table-striped table-bordered sticky_table">
            <thead>
              <tr>
                {TEMPLATE_COLUMNS.map((col) => (
                  <th key={col.accessor}>{col.Header}</th>
                ))}
                <th>Download</th>
              </tr>
            </thead>
            <tbody>
              {pageRows.length ? (
                pageRows.map((row, index) => (
                  <tr key={`${row.templateCode}-${row.batchno}-${index}`}>
                    {TEMPLATE_COLUMNS.map((col) => (
                      <td key={col.accessor}>{row[col.accessor] ?? ""}</td>
                    ))}
                    <td>
                      <button
                        type="button"
                        className="btn btn-primary btn-sm d-flex align-items-center"
                        title="Download QR Code list"
                        onClick={() => onDownload(row.templateCode)}
                      >
                        <span>Download</span>
                        <i className="fa-solid fa-file-excel ms-2"></i>
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={TEMPLATE_COLUMNS.length + 1}
                    style={{
                      textAlign: "center",
                      display: "table-cell",
                      textTransform: "Capitalize",
                    }}
                  >
                    No data found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        totalRecords={data.length}
        onPageChange={setCurrentPage}
      />
    </>
  );
};

export default TemplateTable;
